<div class="module-toggle" [class.module-toggle--inactive]="!control.value">
  @if (field.icon) {
    <span class="module-toggle__icon">
      <app-svg-icon [src]="field.icon"/>
    </span>
  }

  <span class="module-toggle__text">
    <span class="module-toggle__title">{{ field.label }}</span>
    @if (field.description) {
      <span class="module-toggle__description">{{ field.description }}</span>
    }
  </span>

  <label class="module-toggle__switch">
    <input
      type="checkbox"
      class="module-toggle__input"
      [formControl]="control"
      [attr.aria-label]="field.label"
    />
    <span class="module-toggle__track" aria-hidden="true"></span>
  </label>
</div>
